//aman
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import storage from '../../../Storage';
import socket from '../../../Socket';
import { Event, wait, decode, encode, sendNotfication, RECAPTCHA } from '../../../Helper';
import C from '../../../Constant';
import { handleGoogleLogin, GoogleLoginButton } from './GoogleLoginButton';
import Google from './Google';
import { Eye, EyeOff } from "lucide-react";
import { Link } from 'react-router-dom';


const StyledModal = styled(Modal)`
  .modal-content {
    background-color: rgb(35 38 38);
    color: white;
    border-radius: 18px;
    overflow: hidden;
    display:flex;
    flex-direction:row;

    @media(max-width:340px){
      margin:5px !important;
    }
  }
    .modal-md{
    @media(min-width:640px){
      max-width:50rem !important;
    }
    }  
`;

const ModalHeader = styled.div`
  background-color transparent;
  // padding: 10px;
  padding-left:15px;
  padding-right:15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display:flex;
  justify-content:flex-end;

  @media(max-width:640px){
     display:none;
  }
`;

const ModalBody = styled(Modal.Body)`
  // padding: 20px;

  @media(max-width:400px){
  padding:0px;
  padding-top:10px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const StyledInput = styled.input`
  background-color: #1E2121;
  border: 1px solid #3A4142;
  border-radius: 7px;
  color: white;
  padding: 7px;
  font-size: clamp(5px, 3vw, 12px);
  width: 100%;
  padding-right: 35px; /* Make space for the eye icon */
  
  &::placeholder {
    color: #9CA3AF;
    font-weight: 500;
  }
  
  &:focus {
    outline: none;
    border-color: #83EA77;
    box-shadow: 0 0 0 0.5px #83EA77;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const EyeIcon = styled.button`
  position: absolute;
  right: 10px; /* Adjust the position */
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #9CA3AF;
`;

const StyledButton = styled.button`
  background-color: #8c52ff;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 10px;
  font-weight: bold;
  cursor: pointer;
  &:disabled {
    opacity: 0.7;
  }
`;

const SocialLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const SocialLoginButton = styled.button`
  background-color: #2b2f33;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;


const StyledSignInButton = styled.div`
  font-size: 16px;
  color:white !important;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  padding: 8px 13px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
`;

const Labeltext = styled.div`
color:#696F79;
font-size:14px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content:center;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 7px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const SignInButton = styled(Button)`
   background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
  color: black;
  border: none;
  width: 100%;
  max-width: 100%;
  max-height:100%;
  margin-top:10px;

  &:hover {
    background-color: #7c3aed;
  }
`;

const SignUpButton = styled.div`
  color: #9fe871;
  background:transparent;
  width: 100%;
`;

const TwoFAModal = styled(Modal)`
    // Add any custom styles you want here
    .modal-content {
    background-color: #1e2124;
    color: white;
    border-radius: 18px;
    overflow: hidden;
  }
`;

const CloseButtonNew = styled.div`
position:absolute;
top:10px;
right:10px;
font-size:18px;
display:none;

@media(max-width:640px){
display:block;
}
`


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: storage.getKey('logged'),
      show: this.props.show ? this.props.show : false,
      username: '',
      password: '',
      submitted: false,
      disabled: false,
      isLoading: false,
      status: false,
      effect: 'zoomIn',
      show2faModal: false,
      verificationCode: '',
      showPassword: false,
    };

  }


  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    socket.on(C.LOGIN_USER, data => this.setLogin(decode(data)));
    Event.on('login_form', () => {
      this.handleShow();
    });
  }

  setLogin = (data) => {

    // 🔑 Stop loading first
    this.setState({ isLoading: false, disabled: false });

    // 2FA case
    if (data.status === '2fa') {
      Cookies.set("session", data.token, { expires: 14 });
      storage.setKey('token', data.token);
      socket.connect(data.token);
      this.setState({ show2faModal: true });
      return;
    }

    // Success
    if (data.status === true) {

      if (window.Adjust) {
        Adjust.trackEvent("c30xe0");
      }

      sendNotfication('Successfully Login, Please Wait...', 'success', 'bottom-left');

      Cookies.set("session", data.token, { expires: 14 });
      storage.setKey('logged', true);
      storage.setKey('token', data.token);
      storage.setKey('name', data.name);
      storage.setKey('avatar', data.avatar);
      storage.setKey('email', data.email);
      storage.setKey('credit', data.credit);
      storage.setKey('room', data.room);
      storage.setKey('friends', data.friends);
      storage.setKey("coin", "INR");
      storage.setKey("currency", data?.currency);

      wait(500).then(() => window.location.reload());
    }
    // Error
    else {
      sendNotfication(data.status || 'Login failed', 'error', 'bottom-left');
    }
  };


  handleShow = () => {
    this.setState({ show: true, effect: 'zoomIn' });
  }

  handleClose = () => {
    this.setState({ show: false, effect: 'zoomOut', disabled: false, status: false, submitted: false });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submitted: true });

    const { username, password } = this.state;

    if (!(username && password)) {
      sendNotfication('Username and password required', 'error', 'bottom-left');
      return;
    }

    // ✅ Start loading AFTER validation
    this.setState({ isLoading: true, disabled: true, status: 'Please wait' });

    socket.emit(
      C.LOGIN_USER,
      encode({
        username,
        password,
        recaptcha: 'google',
      })
    );
  };


  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  signup = (e) => {
    e.preventDefault();
    this.handleClose();
    Event.emit('register_form');
  }

  handle2FAClose = () => {
    this.setState({ show2faModal: false, verificationCode: '' });
  };

  handle2FASubmit = (e) => {
    e.preventDefault();
    const { verificationCode, password } = this.state;

    this.setState({ isLoading: true });

    socket.emit(C.TWO_FA_CONFIRM, encode({ code: verificationCode, password }));

    socket.once(C.TWO_FA_CONFIRM, (result) => {
      const decodedResult = decode(result);
      this.setState({ isLoading: false });

      if (decodedResult.status === true) {
        sendNotfication('Verification successful!', 'success', 'bottom-left');
        window.location.reload();
      } else {
        sendNotfication(decodedResult.message || 'Verification failed', 'error', 'bottom-left');
        this.setState({ verificationCode: '' });
      }
    });
  };




  render() {
    const { show, username, password, disabled, show2faModal, showPassword } = this.state;

    return (
      <>
        {storage.getKey('logged') ? false : <StyledSignInButton onClick={e => this.handleShow(e)} className='login-btn' style={{ border: "1px solid gray" }}>
          Sign in
        </StyledSignInButton>}

        <StyledModal
          size="md"
          centered
          show={storage.getKey('logged') ? false : show}
          onHide={this.handleClose}
          aria-labelledby="login-modal"
          className={`animated ${this.state.effect}`}
        >
          <div className='login-main'>
            <div className='login-left'>
              <img className='login-top-img' src='\assets\bcimages\login\login-top-img.webp' />
              <img className='login-top-img-2' src='\assets\bcimages\login\login-banner-2.webp' />
              <img className='login-logo-img' src={process.env.REACT_APP_LG_LOGO} />
              <CloseButtonNew onClick={this.handleClose}>×</CloseButtonNew>
              <div className='login-content'>
                <p className='login-content-title'>Stay Untamed</p>
                <p className='login-content-desc'>Sign Up & Get Welcome Bonus</p>
              </div>
            </div>

            <div className='login-right'>
              <ModalHeader>
                <p className='signin-text-header'>Sign in</p>
                {/* <img src="/assets/images/nanogames-logo.png" alt="NanoGames" style={{height: '30px'}} /> */}
                <CloseButton onClick={this.handleClose}>×</CloseButton>
              </ModalHeader>
              <ModalBody>

                <StyledForm onSubmit={this.handleSubmit}>
                  <StyledInput
                    name="username"
                    value={username}
                    onChange={this.handleInputChange}
                    placeholder="Username"
                  />

                  <InputContainer>
                    <StyledInput
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={password}
                      onChange={this.handleInputChange}
                      placeholder="Password"
                    />
                    <EyeIcon type="button" onClick={this.togglePasswordVisibility}>
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </EyeIcon>
                  </InputContainer>

                  <div className="text-right">
                    <Link to="/resetPassword" >Forgot password?</Link>
                  </div>



                  <ButtonContainer>
                    <SignInButton type="submit" disabled={this.state.isLoading}>
                      {this.state.isLoading && (
                        <span
                          className="spinner-grow spinner-grow-sm mr-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Sign In
                    </SignInButton>
                  </ButtonContainer>


                  <div className="signup-button">
                    New to {process.env.REACT_APP_LINK}?
                    <SignUpButton onClick={this.signup}>Create Account</SignUpButton>
                  </div>
                </StyledForm>
                {/* <div className="text-center mt-3">
                            <span>Don't have an account? </span>
                            <a href="#" onClick={this.register}>Sign up</a>
                        </div> */}


              </ModalBody>
            </div>
          </div>
        </StyledModal>
        <TwoFAModal
          size="sm"
          centered
          show={show2faModal}
          onHide={this.handle2FAClose}
          aria-labelledby="2fa-modal"
        >
          <ModalHeader>
            <CloseButton onClick={this.handle2FAClose}>×</CloseButton>
          </ModalHeader>
          <ModalBody>
            <h4>Enter 2FA Code</h4>
            <StyledForm onSubmit={this.handle2FASubmit}>
              <StyledInput
                type="text"
                name="verificationCode"
                value={this.state.verificationCode}
                onChange={this.handleInputChange}
                placeholder="Enter 6-digit code"
                maxLength="6"
              />
              <ButtonContainer>
                <SignInButton type="submit">Verify</SignInButton>
              </ButtonContainer>
            </StyledForm>
          </ModalBody>
        </TwoFAModal>


      </>
    );
  }
}

export default Login;
